<template>
    <div class="container">
  <div class="px-4 py-5 text-center text-light h-50">
    <h2 class="display-4 fw-bold">Rick and Morty</h2>
    <div class="col-lg-6 mx-auto">
      <p class="lead mb-4">This site has been put together using <code>Vue</code> and some frontend helpers provided by <code>Bootstrap</code>. The site uses the Rick and Morty API endpoints. The API is consumed via the <code>Fetch API</code></p>
      <p>Vue 3 | NodeJS - NPM | Bootstrap | SCSS</p>
      <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">
        <button type="button" class="btn btn-outline-secondary btn-lg px-4">R&M Vue</button>
        <a href="/files/rmv.apk" download="rmv.apk"><img src="../assets/img/logos/play.png" alt="download android app" width="48" height="48"></a>
      </div>
    </div>
    <div class="overflow-hidden">
      <div class="container px-5">
        <a href="https://rmvue.saqibofficial.com/" target="_blank"><img src="../assets/img/rmvuethumbnail.png" class="img-fluid border rounded-3 shadow-lg mb-4" alt="cv site" width="700" height="900" loading="lazy"></a>      </div>
    </div>
  </div>
</div>
</template>